import {
  Box,
  Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
// import { Img } from "@storybook/components";
import JSZip from "jszip";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import approvedIcon from "../../assets/Approvata.svg";
import pendingIcon from "../../assets/In attesa.svg";
import rejectedIcon from "../../assets/Negata.svg";
import { Icon } from "../../components";
import CertificateSection from "../../components/Section/CertificateSection";
import DettagliDidatticiSection from "../../components/Section/EducationalDetails";
import InformationTrainingSection from "../../components/Section/InformationTrainingSection";
import LogisticaSection from "../../components/Section/LogisticaSection";
import ObiettiviFormativiSection from "../../components/Section/TrainingObjectives";
import { CompletedButton } from "../../components/SignupSummary/SignupSummaryExternalTraining.component";
import { useDownloadAttachmentsZip } from "../../queries/skillbook";
import { FormValues, Errors, MultiSelectOptionsProps, Field, Domain } from "../../routes/Profile/AddSkillBook/AddSkillBook.types";
import { ButtonBookmark } from "../Button";
import CustomFieldsSection from "../Section/CustomFieldsSection";
import { Options } from "components/InputCst/MultiSelectCst/types";





interface ExternalTrainingPageProps {
  formValues: FormValues;
  setFormValues: React.Dispatch<React.SetStateAction<FormValues>>;
  filter: string;
  formData: Field[];
  handleDateChange: (name: string) => (date: Date | null) => void;
  courseTypes: Options[];
  campaignOptions: Options[];
  knowledgeAreas: MultiSelectOptionsProps[];
  knowledgeDomains: MultiSelectOptionsProps[];
  capabilities: MultiSelectOptionsProps[];
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setSelectedArea: React.Dispatch<React.SetStateAction<{ isUpdating: boolean; value?: string | number }>>;
  handleChangeMultiSelect: (
    event: { label: string; value: string | number }[],
    accessorKey: string
  ) => void;
  selectedCourse: CourseItem | null;
  errors: Errors;
  completedFlag: boolean;
  setCompletedFlag: React.Dispatch<React.SetStateAction<boolean>>;
  readOnly?: boolean;
}


export function ExternalTrainingPage({
  formValues,
  setFormValues,
  filter,
  formData,
  handleDateChange,
  courseTypes,
  campaignOptions,
  knowledgeAreas,
  knowledgeDomains,
  capabilities,
  handleInputChange,
  setSelectedArea,
  handleChangeMultiSelect,
  selectedCourse,
  errors,
  completedFlag,
  setCompletedFlag,
  readOnly
}: ExternalTrainingPageProps)  {

  console.log("🔍 selectedCourse:", selectedCourse);

  const { t } = useTranslation();
  const theme = useTheme();
  const [editingTitle, setEditingTitle] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded(prev => !prev);
  const [expandedLogistica, setExpandedLogistica] = useState(false);
  const toggleExpandedLogistica = () => setExpandedLogistica(prev => !prev);
  const [expandedObiettivi, setExpandedObiettivi] = useState(false);
  const toggleExpandedObiettivi = () => setExpandedObiettivi(prev => !prev);
  const [expandedDettagli, setExpandedDettagli] = useState(false);
  const toggleExpandedDettagli = () => setExpandedDettagli(prev => !prev);
  const [expandedCustomFields, setExpandedCustomFields] = useState(false);
  const toggleExpandedCustomFields = () => setExpandedCustomFields(prev => !prev);

  useEffect(() => {
    if (editingTitle && inputRef.current) {
      inputRef.current.focus();
    }
  }, [editingTitle]);

  const { mutateAsync: mutateDownloadAttachmentsZip } = useDownloadAttachmentsZip();

  useEffect(() => {
    if (selectedCourse) {

      const defaultOptionTrainingMode = courseTypes.find(
        opt => opt.label === selectedCourse.trainingMode
      ) || { label: "-", value: "" };
      setFormValues({
        title: selectedCourse.title,
        provider: selectedCourse.provider,
        startDate: selectedCourse.startDate,
        endDate: selectedCourse.endDate,
        type: selectedCourse.type,
        duration: selectedCourse.duration,
        durationParticipation: selectedCourse.durationParticipation ?? 0,
        cost: selectedCourse.cost,
        data_inizio_validita: selectedCourse.certificateStartValidityDate ?? "",
        data_fine_validita: selectedCourse.certificateEndValidityDate ?? "",
        link_download_certificato: selectedCourse.pdfKey ?? "",
        motivation: selectedCourse.motivation ?? "",
        link_certificato: selectedCourse.certificate_url?? "",
        area_domain: selectedCourse.area
          ? selectedCourse.area.flatMap(areaItem =>
            (areaItem.domain || []).map((domainItem: Domain) => ({
              knowledge_area: {
                label: areaItem.label,
                value: areaItem.id
              },
              knowledge_domain: {
                label: domainItem.label,
                value: domainItem.id
              }
            }))
          )
          : [],
        location: selectedCourse.location,
        campaign: selectedCourse.campaign,
        teacher: selectedCourse.instructor,
        businessTrip:
              typeof selectedCourse.businessTrip === "boolean"
                ? (selectedCourse.businessTrip ? "SI" : "NO")
                : "",
        capability: selectedCourse.capability
          ? selectedCourse.capability.map(c => ({ value: c.id, label: c.label }))
          : [],
        trainingType: defaultOptionTrainingMode,
        description: selectedCourse.description,
        plan: selectedCourse.plan,
        campaignId: selectedCourse.campaignId,
        customFields: selectedCourse.customFields

      });

      const fetchAndUnzip = async () => {
        const zipBlob = await mutateDownloadAttachmentsZip({
          id: Number(selectedCourse.id),
          isExternalCertificate: selectedCourse.type === "Consuntivazione"
        });
        const files = await unzipToFileArray(zipBlob);

        setFormValues(prev => ({
          ...prev,
          attachments: files
        }));
      };
      fetchAndUnzip();
    }
  }, [selectedCourse]);

  const unzipToFileArray = async (zipBlob: Blob): Promise<File[]> => {
    const zip = await JSZip.loadAsync(zipBlob);
    const files: File[] = [];

    for (const [fileName, zipEntry] of Object.entries(zip.files)) {
      if (!zipEntry.dir) {
        const fileData = await zipEntry.async("arraybuffer");
        let mimeType = "";
        if (fileName.endsWith(".pdf")) mimeType = "application/pdf";
        else if (fileName.endsWith(".png")) mimeType = "image/png";
        else if (fileName.endsWith(".jpg") || fileName.endsWith(".jpeg")) mimeType = "image/jpeg";

        const file = new File(
          [fileData],
          fileName,
          { type: mimeType }
        );

        files.push(file);
      }
    }
    return files;
  };

  return (
    <>
      <Box
        sx={ {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          mb: 2,
          px: 2
        } }
      >
        <Box sx={ { flexGrow: 1 } }>
          { editingTitle ? (
            <input
              ref={ inputRef }
              value={ formValues.title as string }
              onChange={ (e) =>
                setFormValues((prev) => ({ ...prev, title: e.target.value }))
              }

              onBlur={ () => setEditingTitle(false) }
              style={ {
                lineHeight: "48px",
                backgroundColor: theme.customColors.backgroundPrimary,
                border: `${theme.customColors.borderAccent} 1px solid`,
                borderRadius: "8px",
                padding: "0 12px",
                color: theme.customColors.textPrimary,
                fontSize: "1.5rem",
                fontWeight: "bold",
                width: "100%",
                verticalAlign: "middle"
              } }
              disabled={ readOnly }
            />
          ) : (
            <Typography color={ theme.customColors.textPrimary } sx={ { fontSize: "1.5rem", fontWeight: "bold", height: "48px" } }>
              { formValues.title as string }
            </Typography>
          ) }
        </Box>
        <ButtonBookmark
          aria-label={ t("upload_file") }
          onClick={ () => setEditingTitle(true) }
          variant="contained"
          sx={ {
            ".icon path":{
              fill: theme.customColors.textPrimaryCta
            },
            height: "48px",
            width: "48px",
            borderRadius: theme.spacing(1),
            bottom: theme.spacing(-1),
            boxShadow: "none",
            minWidth: "unset",
            padding: theme.spacing(1),
            display: "flex",
            right: theme.spacing(-1)
          } }
          disabled={ readOnly }
        >
          <Icon
            icon="Icons_modifica"
            size="1.5rem"
          />
        </ButtonBookmark>
      </Box>
      { /* <IconButton sx={ { color: theme.customColors.accentVariantA, ml: 1 } } onClick={ () => setEditingTitle(true) }>
          <Img
            src={ modificaIcon }
            alt="Modifica"
            width={ 40 }
            height={ 40 }
            style={ {
              display: "block",
              margin: "auto",
              filter: theme.customColors.textPrimary === "#FFFFFF"
                ? "invert(0%)"
                : "invert(100%)"
            } }
          />
        </IconButton> */ }

      <Typography sx={ { color: theme.customColors.textPrimary, fontSize: "1.1rem", mb: 2, display: "flex", alignItems: "center", gap: 1 } }>
        { selectedCourse?.status === "APPROVED" && (
          <>
            <img src={ approvedIcon } alt="Approvato" style={ { width: 20, height: 20 } } loading="lazy"/>
            { t("approved") }
          </>
        ) }
        { selectedCourse?.status === "REJECTED" && (
          <>
            <img src={ rejectedIcon } alt="Rifiutato" style={ { width: 20, height: 20 } } loading="lazy"/>
            { t("rejected") }
          </>
        ) }
        { selectedCourse?.status === "PENDING" && (
          <>
            <img src={ pendingIcon } alt="In attesa" style={ { width: 20, height: 20 } } loading="lazy"/>
            { t("pending") }
          </>
        ) }
      </Typography>
      <Box
        sx={ {
          flexGrow: 1,
          overflowY: "auto",
          pt: 1,
          pr: 1,
          pl: 1,
          mr: -1,
          maxHeight: {
            xs: "none",
            lg: "775px"
          },
          paddingBottom: "80px",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none"
          }
        } }
      >
        { /* Scheda Informazioni corso */ }
        <InformationTrainingSection
          formValues={ formValues }
          setFormValues={ setFormValues }
          readOnly={ readOnly }
        />

        { /* Segna come completato */ }
        { (filter === "all" || filter === "iscrizioni" ) &&
          <Box sx={ { backgroundColor: "#EC407A", color: theme.customColors.textPrimary, borderRadius: 2, mb: 2, border: "1px" } }>
            <CompletedButton
              completed={ completedFlag }
              setCompleted={ setCompletedFlag }
              readOnly={ readOnly }
            />
          </Box>
        }

        <CertificateSection
          formData={ formData }
          formValues={ formValues }
          setFormValues= { setFormValues }
          handleDateChange={ handleDateChange }
          onToggle={ toggleExpanded }
          expanded={ expanded }
          readOnly={ readOnly }
          selectedCourse={ selectedCourse }
        />

        { /* Accordion Logistica */ }

        <LogisticaSection
          expanded={ expandedLogistica }
          onToggle={ toggleExpandedLogistica }
          formValues={ formValues }
          setFormValues={ setFormValues }
          errors={ errors }
          trainingTypeOptions={ courseTypes }
          t={ t }
          handleDateChange={ handleDateChange }
          readOnly={ readOnly } />

        { /* Accordion Obiettivi formativi */ }
        <ObiettiviFormativiSection
          expanded={ expandedObiettivi }
          onToggle={ toggleExpandedObiettivi }
          formValues={ formValues }
          setFormValues={ setFormValues }
          errors={ errors }
          t={ t }
          campaignOptions={ campaignOptions }
          knowledgeAreas={ knowledgeAreas }
          knowledgeDomains={ knowledgeDomains }
          capabilities={ capabilities }
          handleInputChange={ handleInputChange }
          onKnowledgeAreaChange={ (val) => setSelectedArea({ isUpdating: true, value: val }) }
          handleMultiSelectChange={ handleChangeMultiSelect }
          readOnly={ readOnly }
        />


        { /* Accordion Dettagli didattici */ }
        <DettagliDidatticiSection
          expanded={ expandedDettagli }
          onToggle={ toggleExpandedDettagli }
          formValues={ formValues }
          setFormValues={ setFormValues }
          errors={ errors }
          t={ t }
          readOnly={ readOnly }
        />

        { /* Accordion Custom Fields */ }
        <CustomFieldsSection
          expanded={ expandedCustomFields }
          onToggle={ toggleExpandedCustomFields }
          formValues={ formValues }
          setFormValues={ setFormValues }
          errors={ errors }
          t={ t }
          readOnly={ readOnly }
        />


      </Box>
    </>
  );
}
